<template>
  <div
    class="t-notification-group"
    :class="[
      `t-notification-group--${position}`,
    ]"
  >
    <slot></slot>
  </div>
</template>

<script>
import { notificationPositionOptions } from '../../enums';

export default {
  name: 't-notification-group',

  props: {
    position: {
      type: String,
      default: notificationPositionOptions.TOP_RIGHT,
      validator: (value) => Object.values(notificationPositionOptions).includes(value),
    },
  },
};
</script>
